import React from 'react';

import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Button,
} from '@material-ui/core';
import { makeStyles, createStyles, Theme } from '@material-ui/core';
import Markdown from 'react-markdown';

import { IDataset, IFolderNode } from '../../types/dataset';
import FolderView from './tree';
import { makeBucketUrl } from '../../utils/s3';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      marginBottom: theme.spacing(2),
    },
    treeView: {
      marginTop: theme.spacing(2),
    },
  })
);

interface Props {
  dataset?: IDataset;
  folderTree?: IFolderNode;
  onNodeClick: (node: IFolderNode) => void;
}

const DatasetComponent = ({ dataset, folderTree, onNodeClick }: Props) => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <Card className={classes.card}>
        <CardHeader title={dataset?.name} />
        <CardContent>
          <Typography component="div">
            <Markdown>{dataset?.content}</Markdown>
          </Typography>
        </CardContent>
      </Card>

      <Card className={classes.card}>
        <CardHeader title="Files" />
        <CardContent>
          <Button
            variant="outlined"
            color="primary"
            href={`${makeBucketUrl(dataset?.bucket || '')}/${
              dataset?.archiveKey || ''
            }`}
          >
            Download dataset
          </Button>
          {folderTree && (
            <div className={classes.treeView}>
              <FolderView node={folderTree} onClick={onNodeClick} />
            </div>
          )}
        </CardContent>
      </Card>
    </React.Fragment>
  );
};

export default DatasetComponent;
